import React from "react";
import { Animated } from "react-animated-css";
const Warning = ({ msg, className }) => {
  return (
    <div className="w-[90vw] md:w-[60vw] fixed bottom-[100px] md:bottom-8 left-[5vw] md:left-[20vw] z-[100]">
      <div
        className={`container mx-auto flex items-center justify-center   ${className}`}
      >
        <Animated animationIn="bounceInUp">
          <div
            className="border-2 p-4 w-auto inline-block rounded-xl bg-white shadow-md relative"
            style={{
              // borderColor: "#EEC9B5",
              borderColor: "var(--orange)",
            }}
          >
            <p className="font-bold lowercase text-[13px]">{msg}</p>
          </div>
        </Animated>
      </div>
    </div>
  );
};

export default Warning;
